import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout';
import OwnerPortalEntry from './pages/owner/OwnerPortalEntry';
import OwnerPlanView from './pages/owner/OwnerPlanView';
import OwnerSignup from './pages/owner/OwnerSignup';
import TrainerDashboard from './pages/trainer/TrainerDashboard';
import TrainerLogin from './pages/trainer/TrainerLogin';
import CompleteTrainerProfile from './pages/trainer/CompleteTrainerProfile';
import AccountRequest from './pages/trainer/AccountRequest';

function App() {
  return (
    <Router>
      <AppLayout>
        <Routes>
          {/* Public Owner Routes */}
          <Route path="/portal" element={<OwnerPortalEntry />} />
          <Route path="/portal/plan/:planId" element={<OwnerPlanView />} />
          <Route path="/signup" element={<OwnerSignup />} />
          
          {/* Trainer Routes */}
          <Route path="/trainer-login" element={<TrainerLogin />} />
          <Route path="/complete-trainer-profile" element={<CompleteTrainerProfile />} />
          <Route path="/dashboard" element={<TrainerDashboard />} />
          <Route path="/request-account" element={<AccountRequest />} />
          
          <Route path="/login" element={<Navigate to="/trainer-login" replace />} />
          <Route path="/" element={<Navigate to="/portal" replace />} />
        </Routes>
      </AppLayout>
    </Router>
  );
}

export default App;